import { RunContextApp }        from "framework/RCApp"
import { combineReducers }      from "redux"
import { sessionReducer } from "./SessionReducer"

export const allReducers = (rc : RunContextApp) => combineReducers({
  session : sessionReducer(rc)
})